<template>
  <div class="lottery">
    <!-- 顶部综合背景区 -->
    <div class="top-header-wrap">
      <!-- 顶部导航栏 -->
      <div class="lottery-nav van-nav-bar">
        <div class="van-nav-bar__content">
          <div class="van-nav-bar__left" @click="back()">
            <i class="van-icon van-icon-arrow-left van-nav-bar__arrow"></i>
          </div>
          <div class="van-nav-bar__title van-ellipsis">{{ lottery.name || '啟動數據' }}</div>
          <div class="van-nav-bar__right" @click="showRight">
            <span class="van-nav-bar__text">切換</span>
          </div>
        </div>
      </div>

      <!-- 顶栏期号与倒计时 -->
      <div class="qs-bar">
        <div class="qs-left">
          <div class="ico">
            <img :src="getLotteryIco(lottery.ico)" alt="">
          </div>
          <span class="expect-num">{{ lottery.next_expect || lottery.now_expect }}</span>
        </div>
        <div class="countdown-wrap">
          <span class="countdown-label">倒計時:</span>
          <van-count-down :time="time" @finish="check()" />
        </div>
      </div>

      <!-- 投票结果与上期信息 -->
      <div class="number-card" v-if="lottery.now_expect">
        <div class="number-left">
          <div>{{ lottery.now_expect }}</div>
          <div>投票結果</div>
        </div>
        <div class="number-divider"></div>
        <div class="number-right-pill">
          <div class="number-res-balls">
            <span class="res-ball">{{ sum }}</span>
            <span class="res-ball">{{ size }}</span>
            <span class="res-ball">{{ double }}</span>
          </div>
          <i
            class="van-icon van-icon-arrow-down"
            :class="{ up: active }"
            @click="active = !active"
          ></i>
        </div>
      </div>
    </div>

    <!-- 历史记录下拉框 -->
    <div class="history" v-if="active">
      <div class="history-inner">
        <ul>
          <li v-for="(item, index) in lottery_list" :key="index" class="history-row">
            <span class="history-left">{{ item.expect }}</span>
            <div class="history-res">
              <span>{{ getSum(item.opencode) }}</span>
              <span>{{ getSize(item.opencode) }}</span>
              <span>{{ getDouble(item.opencode) }}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <!-- 中间选项区域（意 亂 情 迷 4选项卡） -->
    <div class="lottery-content">
      <div class="right">
        <div class="ball">
          <div class="idx0-wrap">
            <div
              class="idx0"
              :class="{ active: choose['big'] }"
              @click="choosePlay('big', rose)"
            >
              <p>{{ rose }}</p>
            </div>
            <div
              class="idx0"
              :class="{ active: choose['small'] }"
              @click="choosePlay('small', lily)"
            >
              <p>{{ lily }}</p>
            </div>
            <div
              class="idx0"
              :class="{ active: choose['one'] }"
              @click="choosePlay('one', fireworks)"
            >
              <p>{{ fireworks }}</p>
            </div>
            <div
              class="idx0"
              :class="{ active: choose['two'] }"
              @click="choosePlay('two', balloon)"
            >
              <p>{{ balloon }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 选中下注信息明细面板 -->
    <div class="bet-info-panel" v-if="formData.length > 0 && !jiesuanpage">
      <div class="bet-row">
        <span class="label">當前選號:</span>
        <span class="val pink-text">{{ convertedShopchoose }}</span>
      </div>
      <div class="bet-row">
        <span class="label">每單積分:</span>
        <input type="number" v-model="money" placeholder="20" class="money-input">
      </div>
      <div class="bet-row total-info">
        <span>共 <em class="pink-text">{{ formData.length }}</em></span>
        <span style="margin-left: 15px;">合計 <em class="pink-text">{{ totalMoney }}</em> 積分</span>
      </div>
    </div>

    <!-- 底部状态栏 -->
    <div class="foot">
      <p>可用積分: <span class="pink-text">{{ userInfo.money || '0.00' }}</span></p>
      <a href="javascript:;" @click="jiesuan">確認提交</a>
    </div>

    <!-- 提交确认弹窗 -->
    <van-popup v-model="jiesuanpage" position="center">
      <div class="confirm-order-modal">
        <div class="confirm-head">
          <p class="text">任務單</p>
        </div>
        <ul class="list">
          <li v-for="(v, key) in formData" :key="key" class="lise-item">
            <div class="main">
              <p class="bet-name">{{ v.name }}</p>
              <p class="detail-text">1注 X {{ money || 0 }}積分 = {{ money || 0 }}積分</p>
            </div>
            <van-icon name="close" @click="clearChooes(v.type)" />
          </li>
        </ul>
        <div class="sub-bar">
          <button type="button" class="item cancel-btn" @click="allClear">清空訂單</button>
          <button type="button" class="item sub-btn" @click="doSub">確認提交</button>
        </div>
      </div>
    </van-popup>

    <!-- 右侧切换弹窗 -->
    <van-popup v-model="showModel" position="right" :style="{ width: '70%', height: '100%' }">
      <div class="popups">
        <p>連結活動</p>
        <div
          class="ite"
          v-for="(i, index) in gameitemData"
          :key="index"
          @click="tabList(i.id, i.key)"
        >
          <div>
            <img :src="getLotteryIco(i.ico, i.id, i.key)" alt="">
          </div>
          <p>{{ i.name }}</p>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Toast } from 'vant';

var time;
var count = 0;

export default {
  data() {
    return {
      jiesuanpage: false,
      showModel: false,
      rose: '意',
      lily: '亂',
      fireworks: '情',
      balloon: '迷',
      choose: {
        big: false,
        small: false,
        one: false,
        two: false
      },
      shopping: false,
      isLoading: false,
      lottery_peilv_list: [],
      lottery_list: [],
      active: false,
      userInfo: {},
      lottery: {},
      sum: 0,
      size: '意',
      double: '迷',
      time: 0,
      shopchoose: '未選中',
      gameitem: '',
      formData: [],
      money: '20',
      ids: this.$route.query.id || '10',
      keys: this.$route.query.key || 'game1',
      gameitemData: [],
      idImageMap: {
        '10': '/img/game/46b8214d20fe68029ac3909b26f82122.jpg',
        '11': '/img/game/1e30baaa5970ac5503b65760d33f450b.jpg',
        '12': '/img/game/f86a7a3c98f966d0829cebaef3a13016.jpg',
        '13': '/img/game/27217b734ab57ad22c9810976733d53a.jpg',
        'game1': '/img/game/46b8214d20fe68029ac3909b26f82122.jpg',
        '5': '/img/game/1e30baaa5970ac5503b65760d33f450b.jpg',
        'game2': '/img/game/f86a7a3c98f966d0829cebaef3a13016.jpg',
        'game3': '/img/game/27217b734ab57ad22c9810976733d53a.jpg'
      }
    };
  },
  computed: {
    convertedShopchoose() {
      const mapping = {
        big: this.rose,
        small: this.lily,
        one: this.fireworks,
        two: this.balloon
      };
      return this.formData.map(v => mapping[v.type] || v.name).join(',');
    },
    totalMoney() {
      const m = parseFloat(this.money) || 0;
      return m * this.formData.length;
    }
  },
  methods: {
    back() {
      return window.history.back();
    },
    getLotteryIco(ico, targetId, targetKey) {
      if (ico && !ico.includes('tmayui.xyz')) {
        return ico;
      }
      const checkKey = targetId || targetKey || this.ids || this.keys || this.$route.query.id || this.$route.query.key;
      if (checkKey && this.idImageMap[checkKey]) {
        return this.idImageMap[checkKey];
      }
      return '/img/game/46b8214d20fe68029ac3909b26f82122.jpg';
    },
    getSum(opencode) {
      if (!opencode) return 0;
      if (Array.isArray(opencode)) {
        return (Number(opencode[0]) || 0) + (Number(opencode[1]) || 0) + (Number(opencode[2]) || 0);
      }
      if (typeof opencode === 'string') {
        const parts = opencode.split(',').map(Number);
        return (parts[0] || 0) + (parts[1] || 0) + (parts[2] || 0);
      }
      return 0;
    },
    getSize(opencode) {
      const sum = this.getSum(opencode);
      return sum >= 11 ? '意' : '亂';
    },
    getDouble(opencode) {
      const sum = this.getSum(opencode);
      return sum % 2 === 0 ? '迷' : '情';
    },
    doSub() {
      if (!this.money || parseFloat(this.money) <= 0) {
        Toast(this.$t('reservation.price_place'));
        return false;
      }
      if (this.formData.length === 0) {
        Toast(this.$t('reservation.choose_num'));
        return false;
      }
      if (parseFloat(this.userInfo.money || 0) - this.totalMoney < 0) {
        Toast(this.$t('reservation.balance_enough'));
        return false;
      }
      this.$http({
        method: 'post',
        data: {
          item: this.gameitem,
          money: this.money,
          lid: this.lottery.id,
          mid: this.userInfo.id,
          expect: this.lottery.now_expect
        },
        url: 'game_place_order'
      }).then(res => {
        if (res.code === 200) {
          Toast(res.msg || '下單成功');
          this.allClear();
          this.getUserInfo();
        } else if (res.code === 401) {
          Toast(res.msg);
        }
      });
      return true;
    },
    allClear() {
      for (var i = 0; i < this.formData.length; i++) {
        this.choose[this.formData[i]['type']] = false;
      }
      this.formData = [];
      this.money = '20';
      this.shopchoose = '未選中';
      this.gameitem = '';
      this.shopping = false;
      this.jiesuanpage = false;
    },
    showRight() {
      this.showModel = true;
    },
    jiesuan() {
      if (this.formData.length === 0) {
        Toast(this.$t('reservation.choose_num'));
        return false;
      }
      this.jiesuanpage = true;
    },
    clearChooes(type) {
      for (var i = 0; i < this.formData.length; i++) {
        if (type === this.formData[i]['type']) {
          this.formData.splice(i, 1);
          this.choose[type] = false;
          break;
        }
      }
      if (this.formData.length >= 1) {
        this.shopchoose = this.formData.map(item => item.name).join(',');
        this.gameitem = this.formData.map(item => item.type).join(',');
      } else {
        this.shopchoose = '未選中';
        this.gameitem = '';
        this.shopping = false;
        this.jiesuanpage = false;
      }
    },
    choosePlay(type, name) {
      if (this.choose[type] === true) {
        this.choose[type] = false;
        for (var i = 0; i < this.formData.length; i++) {
          if (type === this.formData[i]['type']) {
            this.formData.splice(i, 1);
            break;
          }
        }
      } else {
        this.formData.push({ name: name, type: type });
        this.choose[type] = true;
      }
      if (this.formData.length >= 1) {
        this.shopping = true;
        this.shopchoose = this.formData.map(item => item.name).join(',');
        this.gameitem = this.formData.map(item => item.type).join(',');
      } else {
        this.shopchoose = '未選中';
        this.gameitem = '';
        this.shopping = false;
      }
    },
    check() {
      if (!localStorage.getItem('token')) {
        this.$router.push({ path: '/Login' });
      } else {
        time = window.setInterval(() => {
          setTimeout(() => {
            this.getUserInfo();
            this.getLotteryInfo();
            this.getLotteryList();
            count++;
            if (count > 5) {
              clearInterval(time);
              count = 0;
            }
          }, 0);
        }, 300);
      }
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res && res.code === 200 && res.data) {
          this.userInfo = res.data;
        }
      });
    },
    getLotteryPeilv() {
      const activeId = this.ids || this.$route.query.id || '10';
      this.$http({
        method: 'get',
        data: { id: activeId },
        url: 'lottery_get_peilv'
      }).then(res => {
        if (res && res.code === 200) {
          this.lottery_peilv_list = res.data;
        }
      });
    },
    getLotteryList() {
      const activeKey = this.keys || this.$route.query.key || 'game1';
      this.$http({
        method: 'get',
        data: { key: activeKey },
        url: 'lottery_get_one_list'
      }).then(res => {
        if (res && res.code === 200 && res.data) {
          let list = res.data;
          if (typeof list === 'string') {
            try {
              list = JSON.parse(list);
            } catch (err) {
              console.error(err);
            }
          }
          this.lottery_list = Array.isArray(list) ? list : [];
          this.getLotteryPeilv();
        }
      });
    },
    getGameItem() {
      this.$http({
        method: 'get',
        url: 'lottery_list'
      }).then(res => {
        if (res && res.data) {
          this.gameitemData = res.data;
        }
      });
    },
    tabList(id, key) {
      this.ids = id;
      this.keys = key;
      this.showModel = false;
      this.allClear();
      if (this.$route.query.id !== id || this.$route.query.key !== key) {
        this.$router.replace({ path: "/Lottery", query: { id: id, key: key } });
      }
      this.getUserInfo();
      this.getGameItem();
      this.getLotteryInfo();
      this.getLotteryList();
    },
    getLotteryInfo() {
      const activeKey = this.keys || this.$route.query.key || 'game1';
      this.$http({
        method: 'get',
        data: { key: activeKey },
        url: 'lottery_get_info'
      }).then(res => {
        if (res && res.code === 200 && res.data) {
          if (parseFloat(this.userInfo.money || 0) < parseFloat(res.data.condition || 0)) {
            Toast(this.$t('reservation.contact_admin'));
            this.$router.push({ path: '/Home' });
            return false;
          }
          this.lottery = res.data;
          this.time = Number(res.data.second || 0) * 1000;
          if (this.time / 1000 === 59) {
            Toast(this.$t('reservation.prize_succ') + this.lottery.now_expect);
          }

          const rawOpencode = res.data.opencode;
          this.sum = this.getSum(rawOpencode);
          this.size = this.getSize(rawOpencode);
          this.double = this.getDouble(rawOpencode);
        }
      });
    }
  },
  created() {
    this.ids = this.$route.query.id || '10';
    this.keys = this.$route.query.key || 'game1';
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
    } else {
      this.getUserInfo();
      this.getGameItem();
      this.getLotteryInfo();
      this.getLotteryList();
    }
  },
  destroyed() {
    if (time) clearInterval(time);
  }
};
</script>

<style scoped>
.lottery {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f0f0f0;
  box-sizing: border-box;
}

/* 顶部综合背景区域 */
.top-header-wrap {
  width: 100%;
  background-image: url('/img/mine/login-bg.png'), linear-gradient(90deg, rgb(79, 43, 138), rgb(245, 96, 205));
  background-repeat: no-repeat;
  background-position: top;
  background-size: 100% auto;
  box-sizing: border-box;
  padding-bottom: 8px;
}

.lottery-nav {
  background: transparent !important;
  height: 90px;
}

::v-deep .lottery-nav .van-nav-bar__content {
  height: 90px;
}

::v-deep .lottery-nav .van-nav-bar__title {
  color: #ffffff !important;
  font-size: 34px !important;
  font-weight: 600 !important;
  line-height: 90px !important;
}

::v-deep .lottery-nav .van-icon-arrow-left {
  color: #ffffff !important;
  font-size: 40px !important;
}

::v-deep .lottery-nav .van-nav-bar__text {
  color: #ffffff !important;
  font-size: 30px !important;
}

.qs-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  margin-bottom: 16px;
}

.qs-left {
  display: flex;
  align-items: center;
}

.qs-left .ico {
  width: 90px;
  height: 90px;
  border-radius: 12px;
  overflow: hidden;
  margin-right: 16px;
  background: #ffffff;
}

.qs-left .ico img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.expect-num {
  font-size: 30px;
  font-weight: 600;
  color: #ffffff;
}

.countdown-wrap {
  display: flex;
  align-items: center;
  font-size: 28px;
  color: #ffdf2b;
}

.countdown-label {
  margin-right: 10px;
  color: #ffffff;
}

::v-deep .countdown-wrap .van-count-down {
  color: #ffdf2b !important;
  font-size: 30px !important;
  font-weight: 600 !important;
}

/* 投票结果框 */
.number-card {
  margin: 0 24px 10px;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 12px;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}

.number-left {
  font-size: 22px;
  color: #ffffff;
  line-height: 1.35;
  white-space: nowrap;
}

.number-divider {
  width: 1px;
  height: 44px;
  background: rgba(255, 255, 255, 0.5);
  margin: 0 20px;
}

.number-right-pill {
  flex: 1;
  background: #ffffff;
  border-radius: 10px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
}

.number-res-balls {
  display: flex;
  align-items: center;
  gap: 16px;
}

.res-ball {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: linear-gradient(90deg, #8b73e6, #d75db4);
  color: #ffffff;
  font-size: 22px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
}

.number-right-pill .van-icon {
  color: #ff253f;
  font-size: 30px;
  cursor: pointer;
}

.number-right-pill .van-icon.up {
  transform: rotate(180deg);
  transition: transform 0.3s;
}

/* 历史下拉菜单 */
.history {
  position: absolute;
  width: 100%;
  height: calc(100% - 350px);
  background: rgba(0, 0, 0, 0.25);
  z-index: 9;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.history-inner {
  overflow-y: auto;
  width: 100%;
  height: 500px;
  background: #ffffff;
  padding-top: 10px;
}

.history-inner ul {
  width: 100%;
  padding: 0;
  margin: 0;
  list-style: none;
}

.history-row {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  border-bottom: 1px solid #f5f5f5;
  box-sizing: border-box;
}

.history-left {
  font-size: 26px;
  font-weight: 600;
  color: #333333;
}

.history-res {
  display: flex;
  gap: 12px;
}

.history-res span {
  font-size: 24px;
  font-weight: 600;
  background: linear-gradient(90deg, #8b73e6, #d75db4);
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: 48px;
  height: 48px;
}

/* 4大选项卡区域 */
.lottery-content {
  width: 100%;
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  background: #f0f0f0;
  overflow: hidden;
}

.lottery-content .right {
  flex: 1;
  height: 100%;
  overflow-y: auto;
  padding-bottom: 240px;
}

.lottery-content .ball {
  width: 100%;
  padding: 5% 5% 100px;
  box-sizing: border-box;
}

.idx0-wrap {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

/* 选项卡按钮 */
.idx0 {
  width: 46%;
  height: 160px;
  background: #ffffff;
  border-radius: 16px;
  margin-bottom: 5%;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: all 0.2s;
}

.idx0 p {
  color: #d63f8c;
  font-size: 44px;
  font-weight: 700;
  margin: 0;
}

/* 选中态：粉紫色高亮填充 + 白色文字 */
.idx0.active {
  background: linear-gradient(135deg, #cb6abf, #c157b5);
}

.idx0.active p {
  color: #ffffff;
}

/* 下注信息面板（紧贴底栏上方） */
.bet-info-panel {
  position: fixed;
  bottom: 100px;
  left: 0;
  right: 0;
  background: #ffffff;
  padding: 16px 30px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  border-top: 1px solid #f0f0f0;
  z-index: 8;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.bet-row {
  display: flex;
  align-items: center;
  font-size: 26px;
  color: #333333;
}

.bet-row .label {
  margin-right: 12px;
  color: #333333;
}

.bet-row .money-input {
  width: 220px;
  height: 48px;
  background: #f2f2f5;
  border: none;
  border-radius: 6px;
  text-align: center;
  font-size: 26px;
  color: #333333;
}

.pink-text {
  color: #f560cd !important;
  font-weight: 700;
  font-style: normal;
}

.total-info {
  font-size: 26px;
  color: #333333;
}

/* 底部状态栏 */
.foot {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 100px;
  background: #ffffff;
  padding: 0 30px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  z-index: 10;
  box-sizing: border-box;
  border-top: 1px solid #f5f5f5;
}

.foot p {
  padding-right: 24px;
  font-size: 26px;
  color: #333333;
  margin: 0;
}

.foot a {
  background: linear-gradient(135deg, #a253d0, #d63f8c);
  color: #ffffff;
  border-radius: 12px;
  padding: 16px 36px;
  font-size: 28px;
  text-decoration: none;
  font-weight: 600;
}

/* 弹窗样式 */
.confirm-order-modal {
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 0 0 30px;
  width: 80vw;
  max-width: 90vw;
  height: 600px;
  max-height: 70vh;
  z-index: 10;
  background-color: #ffffff;
  border-radius: 20px;
  overflow: hidden;
}

.confirm-head {
  background: linear-gradient(20deg, #a253d0, #d63f8c);
}

.confirm-head .text {
  padding: 20px 30px;
  text-align: center;
  font-size: 32px;
  font-weight: 500;
  color: #ffffff;
  margin: 0;
}

.confirm-order-modal .list {
  flex: 1;
  padding: 0 30px;
  overflow-y: auto;
  list-style: none;
  margin: 0;
}

.confirm-order-modal .list .lise-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 20px 0;
  border-bottom: 1px solid #f0f0f0;
}

.confirm-order-modal .list .lise-item .main {
  flex: 1;
  overflow: hidden;
}

.confirm-order-modal .list .lise-item .main .bet-name {
  color: #f6379c;
  font-size: 28px;
  font-weight: 500;
  margin: 0 0 10px;
}

.confirm-order-modal .list .lise-item .main .detail-text {
  font-size: 24px;
  color: #5739ab;
  margin: 0;
}

.confirm-order-modal .sub-bar {
  display: flex;
  align-items: center;
  margin-top: 20px;
  justify-content: space-around;
  padding: 0 30px;
}

.confirm-order-modal .sub-bar .item {
  min-width: 40%;
  height: 80px;
  text-align: center;
  box-sizing: border-box;
  border-radius: 100px;
  font-size: 28px;
  font-weight: 500;
  cursor: pointer;
}

.confirm-order-modal .sub-bar .cancel-btn {
  border: 1px solid #979799;
  color: #000000;
  background-color: #ffffff;
}

.confirm-order-modal .sub-bar .sub-btn {
  background: linear-gradient(20deg, #8673e5, #d958a4);
  color: #ffffff;
  border: 0;
}

.popups {
  width: 100%;
  padding: 80px 20px 30px;
  background: #e4e4e7;
  min-height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: stretch;
  gap: 16px;
  position: relative;
}

.popups > p {
  position: absolute;
  font-weight: 600;
  font-size: 28px;
  top: 20px;
  left: 20px;
  margin: 0;
}

.popups .ite {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  width: 100%;
  box-sizing: border-box;
  padding: 20px 24px;
  background: #ffffff;
  border-radius: 16px;
}

.popups .ite div {
  flex-shrink: 0;
  width: 100px;
  height: 100px;
  overflow: hidden;
  border-radius: 18px;
}

.popups .ite div img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.popups .ite p {
  flex: 1;
  font-size: 26px;
  padding: 0 0 0 24px;
  margin: 0;
  text-align: left;
}

::v-deep .van-popup--center {
  border-radius: 20px;
}
</style>
